import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Navigation from "./navigation/navigation";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";

function App() {
  return (
    <Router>
      <>
        <Navigation />
        <ToastContainer />
      </>
    </Router>
  );
}

export default App;
